'use client';

import Link from 'next/link';

import { Text } from '@mantine/core';

import AppVersions from '@components/layout/AppVersions/AppVersions';

import { useAppContext } from '@context/AppContext';

import dayjs from '@utils/dayjs';

import classes from './Footer.module.css';

export default function Footer() {
    const [user] = useAppContext('user');
    const [iframe] = useAppContext('iframe');

    if (iframe) {
        return null;
    }
    return (
        <footer className={classes['footer']}>
            {
                user?._id && (
                    <>
                        <Link href="/faq" target="_blank">
                            FAQ
                        </Link>
                        <Text>&bull;</Text>
                    </>
                )
            }
            <a href="https://neylia.com/" target="_blank" rel="noreferrer">
                Neylia
            </a>
            <Text>&bull;</Text>
            <Text>
                {dayjs().year()}
            </Text>
            <AppVersions/>
        </footer>
    );
}
